import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, filter, map, Observable, of, Subscription, switchMap, tap } from 'rxjs';
import { Setting } from '../../../common/settings';
import { Task } from '../../../requests/Model/task';
import { TaskViewModel } from '../../../requests/Model/taskViewModel';
import { RequestService } from '../../../requests/services/requests.services';
import url from 'src/settings.json';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OrganisationService } from '../../../organisation/organisation/services/organisation.service';
import { ModifiedRequest } from '../../../requests/Model/modifiedRequest';
import { ModifiedItem } from '../../../common/modifiedItem';

@Component({
  selector: 'app-task-statistics',
  templateUrl: './task-statistics.component.html',
  styleUrls: ['./task-statistics.component.css']
})

export class TaskStatisticsComponent implements OnInit, OnDestroy {
  @Input() requestId: number | undefined;
  @Input() canModify = false;
  @Input() project!: string;
  taskList: any[] =[];
  isListloading = false;
  /*displayedColumns: string[] = ['id', 'title', 'status', 'shortType'];*/
  displayedColumns: string[] = ['id', 'title', 'shortType'];

  isEditable = false;
  displayedColumnsToEdit: string[] = ['id', 'title', 'shortType', 'action'];  
  isTaskLoading = false;
  addTaskControl = new FormControl(); 
  tasksfilteredOptions!: Observable<any>;
  setting: Setting = url;
  currentOrganisation: any;
  organisationSubscriber?: Subscription;
  newTaskList: Array<Task> = [];
  tasksOptions: Array<Task> = [];
  isModified = false;
  errorMessage = "";
  isTaskAddedSuccessfully = false;
  requestTasksubscription?: Subscription;
  isEmptyList = true;

  reviewRequest: ModifiedRequest = {
    requestId: 0,
    moderators: [],
    tasks: [],    
    reviewers: [],
    modifiedItem: ModifiedItem.Task
  }

  constructor(private readonly route: ActivatedRoute, private readonly router: Router, private readonly requestService: RequestService,
    private readonly http: HttpClient,
    private readonly organisationService: OrganisationService) {
    this.organisationSubscriber = this.organisationService.organisationEmitter.subscribe({
      next: (value: string) => {
        if (value === '') { this.currentOrganisation = this.organisationService.getLocalStorageItem("CurrentOrganisation") }
        else { this.currentOrganisation = value; }
      }
    });    
  }

  ngOnInit() {
    this.getRequestTasks(Number(this.requestId));    

    this.tasksfilteredOptions = this.addTaskControl.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      filter((value) => value !== ""),
      switchMap(val => {
        return this.filterTasks(val)
      }))
  }

  ngOnDestroy(): void {
      this.organisationSubscriber?.unsubscribe();
      this.requestTasksubscription?.unsubscribe();
  }

  getRequestTasks(id: number) {
    this.isListloading = true;
    this.requestTasksubscription= this.requestService.getrequestTasks(id).subscribe({
      next: (response: TaskViewModel[]) => {
        this.taskList = response;
        if (this.taskList) { this.isEmptyList = false; }
      },
      error: (error: any) => {
        console.log(error)
      },
      complete: () => { this.isListloading = false; }
    });
  }

  onEditClick() {
    this.isEditable = true;
    this.taskList.forEach((t) => {
          this.newTaskList.push({ id: t.taskId, title: t.title, shortType: t.shortType });          
    });    
  }
  deleteTask(task: Task) {
    if (this.newTaskList.length > 1) {
      const index = this.newTaskList.indexOf(task);
      this.newTaskList.splice(index, 1);
      this.isModified = true;
    } else {
      this.errorMessage = "The Request must have at least one task."
    }
  }
  onAddTaskSelected(event: MatAutocompleteSelectedEvent) {
    if (this.newTaskList.find(t => t.id === event.option.value) === undefined) {
      var task = this.tasksOptions.find(x => x.id === event.option.value) as Task;
      console.log(task);
      this.newTaskList.push({ id: task.id, title: task.title, shortType: task.shortType });
      this.isModified = true;
    } else {
      this.errorMessage = "This task is already selected!";
    }
    this.tasksOptions = [];
    this.addTaskControl.setValue("");
    event.option.value = '';    
  }

  getTasks(val: string) {
    this.isTaskLoading = true;
    const url = `${this.setting.url}/${this.currentOrganisation}`;    
    const term = new HttpParams().set('term', val).set('project', this.project);    
    return this.tasksOptions?.length ?
      of(this.tasksOptions) :
      this.requestService.getTasksPerProject(term).pipe(tap(data => this.tasksOptions = data))
  }

  filterTasks(val: string): Observable<Task[]> {
    this.errorMessage = "";
    // call the service which makes the http-request    
    return this.getTasks(val)
      .pipe(
        map(response => response?.filter((option: Task) => {
          this.isTaskLoading = false;
          return option.title;
        })))

  }

  onSaveClick() {    
    this.isTaskLoading = true;
    this.reviewRequest.requestId = Number(this.requestId);
    this.reviewRequest.tasks = this.newTaskList;

    this.requestService.modifyTasksOfRequest(this.reviewRequest).subscribe({      
      next: (response: ModifiedRequest) => {
        this.taskList = [];       
        this.getRequestTasks(Number(this.requestId));
        this.isTaskAddedSuccessfully = true;
        this.newTaskList = [];
        this.isEditable = false;
        this.isModified = false;
      },
      error: (err: any) => { this.errorMessage = err.error; },
      complete: () => {
        this.isTaskLoading = false;
        this.tasksOptions = [];
        this.addTaskControl.setValue("");
        this.errorMessage = "";
      }
    });
  }

  onCancelClick() {
    this.isEditable = false;
    this.isModified = false;
    this.newTaskList = [];
    this.tasksOptions = [];
    this.addTaskControl.setValue("");
    this.errorMessage = "";
  } 
}
